import { cn } from '@sshop/ui';

import { publicAssetUrl } from '@/shared/lib/publicAssetUrl';

export function PaymentCardMarks({ className }: { className?: string }) {
  return (
    <div className={cn('flex flex-wrap items-center gap-2', className)}>
      {['visa', 'mastercard'].map((brand) => (
        <img
          key={brand}
          src={publicAssetUrl(`payments/${brand}.svg`)}
          alt={brand === 'visa' ? 'Visa' : 'Mastercard'}
          width={60}
          height={36}
          className="border-border-subtle h-8 w-auto rounded-md border bg-white object-contain"
        />
      ))}
    </div>
  );
}
